module.exports = __webpack_public_path__ + "static/media/work_values.58324baa.svg";